import { z } from "zod"
import { Errors } from "../errors"

export const VaultKeySchema = z
  .string()
  .min(1)
  .max(64)
  .regex(/^[A-Za-z_][A-Za-z0-9_]*$/, { message: Errors.VAULT_KEY_INVALID })
  .refine((key) => !["__proto__", "constructor", "prototype"].includes(key))

export const CreateVaultEntrySchema = z.object({
  key: VaultKeySchema,
  value: z.string().min(1).max(10_000),
  isSecret: z.boolean(),
})

export const ReplaceVaultEntrySchema = z.object({
  value: z.string().min(1).max(10_000),
})

export const VaultEntryParamsSchema = z.object({
  key: VaultKeySchema,
})

export const VaultEntryResponseDataSchema = z.object({
  key: VaultKeySchema,
  isSecret: z.boolean(),
  value: z.string().nullable(),
  createdAt: z.date().transform((date) => date.toISOString()),
  updatedAt: z.date().transform((date) => date.toISOString()),
})

export const VaultEntriesResponseDataSchema = z.array(VaultEntryResponseDataSchema)

export type VaultEntryResponseData = z.output<typeof VaultEntryResponseDataSchema>
